import { PublicClientApplication } from '@azure/msal-browser';

const currentHost = window.location.origin

const msalConfig = {
    auth: {
        clientId: '080e1c2a-5c68-4b30-902e-1aa26a3a9d39',
        authority: 'https://login.microsoftonline.com/organizations',
        redirectUri: currentHost,
        postLogoutRedirectUri: currentHost + '/'
    } 
}

const MsInstance=new PublicClientApplication(msalConfig)

export default MsInstance; 